export const responsiveContainerSx = {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    paddingTop: '24px',
    paddingBottom: '24px',
    whiteSpace: 'pre-line',
} as const;